const SafAndJetAType = {
  JET_A_TYPE: 1,
  SAF_TYPE: 4,
};

export default SafAndJetAType;
